import React from 'react'

export type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  className?: string; // Optional additional styles
};

export const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  className = '',
}) => {
  // TailwindCSS styles for horizontal and vertical dividers
  const baseClass =
    orientation === 'horizontal'
      ? 'border-t w-full h-1'
      : 'border-l h-full w-1'

  return <div className={`${baseClass} border-gray-300 dark:border-gray-600 ${className}`} />
}